import { render } from "./DateInput.vue?vue&type=template&id=0fc6ba1b&ts=true"
import script from "./DateInput.ts?vue&type=script&lang=ts&external"
export * from "./DateInput.ts?vue&type=script&lang=ts&external"

import "./DateInput.vue?vue&type=style&index=0&id=0fc6ba1b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__